/* global $ */

(function (scope) {
  "use strict";

  /**
   * PrintMaterialsView corresponds to the 3 blocks below the viewer on the 3D print page.
   *
   * It's basically doing the same job as the SettingsView, with less options, but presenting
   * our materials more visibly.
   *
   * @param {PrintController} controller
   * @param {Design} design
   */
  var PrintMaterialsView = (scope.PrintMaterialsView = function (
    controller,
    design
  ) {
    this.controller = controller;
    this.design = design;
    this.materials = this.controller.materials;

    this.$el = $(".PrintMaterialsView");

    if (this.$el.length > 0) {
      this.updateSelectors();

      this.$el.on(
        "click",
        ".PrintMaterialsView--process li",
        this.processChanged.bind(this)
      );
      this.$el.on(
        "click",
        ".PrintMaterialsView--materials li",
        this.optionChanged.bind(this)
      );
      this.$el.on(
        "click",
        ".PrintMaterialsView--toggle-description",
        this.toggleDescription.bind(this)
      );
    }
  });

  /**
   * Toggle interractivity on the tool.
   *
   * @param {boolean} enabled
   */
  PrintMaterialsView.prototype.enabled = function (enabled) {
    this.$el.find(".card").toggleClass("disabled", !enabled);
  };

  /**
   * Render selectors based on the currently selected materials
   *
   * @public
   */
  PrintMaterialsView.prototype.updateSelectors = function () {
    var $processContainer = $(".PrintMaterialsView--process", this.$el).empty();
    var $materialsContainer = $(
      ".PrintMaterialsView--materials",
      this.$el
    ).empty();

    this.materials.generateDashboard(
      $processContainer,
      $materialsContainer,
      this.design
    );
    this.updateDescription();
  };

  /**
   * Build and update description's text based on the currently selected material
   *
   */
  PrintMaterialsView.prototype.updateDescription = function () {
    var map = this.materials
      .getMapIndex(
        this.materials.getMapValue(
          this.design.material,
          this.design.order.finish,
          this.design.order.painting,
          this.design.order.options,
          this.design.order.color
        )
      )
      .split(",");
    var $texts = $("<div/>");

    for (var i = 0; i < map.length; i++) {
      var text = this.materials.getMaterialDescription(map[i]);

      if (text) {
        $("<p/>").addClass("text--sm text--grey").html(text).appendTo($texts);
      }
    }

    $(".PrintMaterialsView--description").html($texts.html());
  };

  /**
   * Toggle material description
   *
   * @param {jQuery.event} e (optional)
   */
  PrintMaterialsView.prototype.toggleDescription = function (e) {
    if (e) {
      e.preventDefault();
    }

    var $a = $(".PrintMaterialsView--toggle-description");
    var $d = $(".PrintMaterialsView--description");

    if ($a.hasClass("opened")) {
      $a.removeClass("opened");
      $d.addClass("hidden");
    } else {
      $a.addClass("opened");
      $d.removeClass("hidden");
    }
  };

  /**
   * Event listener for process change
   * Will cause a material change by selecting the default material in the selected process
   *
   * @param {jQuery.Event} e
   * @private
   */
  PrintMaterialsView.prototype.processChanged = function (e) {
    var processValue = $(e.currentTarget).data("value");
    var materialConfig;
    var materialMap = this.materials.findClosestMap(processValue, 0);
    materialConfig =
      this.materials.getMaterialPaintingFinishFromMap(materialMap);
    this.controller.updateMaterial(
      materialConfig.material,
      materialConfig.finish,
      materialConfig.painting,
      "print_new_material_widget",
      undefined,
      materialConfig.color
    );

    if (window.GoogleTagManager) {
      // send tag to TGM
      window.GoogleTagManager.sendTag({
        category: "print",
        action: "print.process",
        label: processValue,
      });
    }
  };

  /**
   * Event listener for material/finish/color/varnish change
   *
   * @param {jQuery.Event} e
   * @private
   */
  PrintMaterialsView.prototype.optionChanged = function (e) {
    var $target = $(e.currentTarget);

    if ($target.hasClass("error-not-available")) {
      return;
    }

    $target.parent().find("li").removeClass("selected");
    $target.addClass("selected");

    var selection = $(".selected", this.$el).toArray();
    selection.sort(function (select_0, select_1) {
      return (
        $(select_0).parent().data("index") - $(select_1).parent().data("index")
      );
    });
    var materialMap = selection
      .map(function (el) {
        return $(el).data("value");
      })
      .join(",");
    var materialConfig;
    var selectorIndex = $target.closest(".row").index() + 1;

    materialMap = this.materials.findClosestMap(materialMap, selectorIndex);
    materialConfig =
      this.materials.getMaterialPaintingFinishFromMap(materialMap);
    this.controller.updateMaterial(
      materialConfig.material,
      materialConfig.finish,
      materialConfig.painting,
      "print_new_material_widget",
      materialConfig.options,
      materialConfig.color
    );

    if (window.GoogleTagManager) {
      // send tag to TGM
      // the name of the category that we are currently changing
      var selectorType = $target.attr("data-selector-type");
      var value = $target.attr("data-value");
      window.GoogleTagManager.sendTag({
        category: "print",
        action: "print." + selectorType,
        label: value,
      });
    }
  };
})((window.sculpteo = window.sculpteo || {}));
